import { CommonChartProps } from '../../types';
import { Line, LineProps, LineChart as RechartsLineChart } from 'recharts';
import { BaseChart } from '../../BaseChart';
import { getAdjustedOpacity } from '../../utils';

export type ExtendedLineProps = React.PropsWithoutRef<LineProps>;
export type LineChartProps<TData> = CommonChartProps<
  TData,
  React.ComponentProps<typeof RechartsLineChart> & { data?: TData[] },
  ExtendedLineProps
>;

export const LineChart = <TData,>(props: LineChartProps<TData>) => {
  return (
    <BaseChart
      {...props}
      chartType="line"
      ChartComponent={RechartsLineChart}
      renderSeries={({ normalizedSeries, activeIndex }) =>
        normalizedSeries.map(({ dataKey, color, ...seriesProps }, index) => (
          <Line
            key={dataKey}
            stroke={color}
            {...seriesProps}
            dataKey={dataKey}
            strokeOpacity={getAdjustedOpacity(
              activeIndex,
              index,
              seriesProps.strokeOpacity,
            )}
          />
        ))
      }
    />
  );
};
